module.exports = __webpack_public_path__ + "static/media/burger-sweet-home-carousel.38a716e1.jpg";